@if (variant === 'horizontal-style-1') {
  <navbar-horizontal-style-1></navbar-horizontal-style-1>
}

@if (variant === 'vertical-style-1') {
  <navbar-vertical-style-1></navbar-vertical-style-1>
}

@if (variant === 'vertical-style-2') {
  <navbar-vertical-style-2 id="navbar-vertical-2"></navbar-vertical-style-2>
}

@if (variant === 'pretty-easy') {
  <!--    <navbar-vertical-style-2></navbar-vertical-style-2>-->
  <app-pretty-easy-navigation role="complementary"></app-pretty-easy-navigation>
}
